import React, { Component } from 'react';
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import ThemePackageList from './ThemePackageList';
import AddThemePackageButton from './AddThemePackageButton';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { categoryActions as actions } from '../../actions';
import '../../content/css/ThemePackage.css';
import { LoadingIcon } from '../LoadingIcon';
import LoadingListener from '../../helpers/loadingListener';

class ThemePackagesView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            themePackages: []
        };

        this.loadingListener = new LoadingListener([], true);
    }

    componentDidMount() {
        this.props.requestAll();
        if (this.props.themePackages) this.setState({ themePackages: this.props.themePackages });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.themePackages !== this.props.themePackages) this.setState({ themePackages: this.props.themePackages });
    }

    handleCreatePackage = (name, contractType) => {
        if (name === "" || contractType === "") return;
        this.props.addThemePackage(name, contractType);
    }

    handleEditPackage = (themePackage) => {
        this.props.editThemePackage(themePackage);
    }

    handleDuplicatePackage = (id) => {
        this.props.duplicateThemePackage(id);
    }

    handleDeletePackage = (id) => {
        this.props.removeThemePackage(id);
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <div className="theme-package-view">
                <div className="title">
                    <h2>Themes</h2>
                    <span>Manage all themes and their concepts, as well as the organizations they belong to.</span>
                </div>
                <Grid fluid>
                    <Panel>
                        <Row>
                            <Col sm={12}>
                                <AddThemePackageButton onClick={this.handleCreatePackage} />
                                <ThemePackageList
                                    themePackages={this.state.themePackages}
                                    isLoading={this.props.isLoading}
                                    onEditPackage={this.handleEditPackage}
                                    onDuplicatePackage={this.handleDuplicatePackage}
                                    onDeletePackage={this.handleDeletePackage}
                                />

                                {isLoading && <LoadingIcon />}
                            </Col>
                        </Row>
                    </Panel>
                </Grid>
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(ThemePackagesView);


// WEBPACK FOOTER //
// ./src/components/CategoryView/ThemePackagesView.js